/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: Io-KM_GdRtNU
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicLogoInDock.module.css"; // plasmic-import: Io-KM_GdRtNU/css
import Icon29Icon from "./icons/PlasmicIcon__Icon29"; // plasmic-import: AFzBqeF1A0gq/icon

createPlasmicElementProxy;

export const PlasmicLogoInDock__VariantProps = new Array();

export const PlasmicLogoInDock__ArgProps = new Array("onClick");

const $$ = {};

function PlasmicLogoInDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <Icon29Icon
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      role={"img"}
    />
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogoInDock__ArgProps,
          internalVariantPropNames: PlasmicLogoInDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogoInDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogoInDock";
  } else {
    func.displayName = `PlasmicLogoInDock.${nodeName}`;
  }
  return func;
}

export const PlasmicLogoInDock = Object.assign(
  // Top-level PlasmicLogoInDock renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicLogoInDock
    internalVariantProps: PlasmicLogoInDock__VariantProps,
    internalArgProps: PlasmicLogoInDock__ArgProps
  }
);

export default PlasmicLogoInDock;
/* prettier-ignore-end */
